import { Button, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { Resource as TResource } from "@/types";
import { getYoutubeId, isYoutubeLink } from "@/utils/youtubeLink";

type ResourceProps = {
  resource: TResource;
};

const Resource = ({ resource }: ResourceProps) => {
  const { t } = useTranslation("onboarding");

  const isLinkValid = resource.url.startsWith("http");
  const isCurrentYoutubeLink = isYoutubeLink(resource.url);

  if (!isLinkValid) {
    return null;
  }

  return (
    <a
      href={resource.url}
      rel="noopener noreferrer"
      target="_blank"
      className="border-grayscale-xx-light p-lg hover:border-grayscale-x-light flex flex-col justify-between rounded-lg border shadow-sm duration-1000 hover:shadow-lg hover:ease-out"
    >
      {resource.title ? (
        <Typography
          step="1"
          weight="bold"
          as="h3"
          className="mb-xs animate-in fade-in"
        >
          {resource.title}
        </Typography>
      ) : null}
      {resource.description ? (
        <Typography className="mb-xs animate-in fade-in">
          {resource.description}
        </Typography>
      ) : null}
      {isCurrentYoutubeLink ? (
        <iframe
          id="player"
          width="100%"
          height="190px"
          className="animate-in fade-in rounded-md duration-1000"
          src={`https://www.youtube.com/embed/${getYoutubeId(resource.url)}?enablejsapi=1&origin=${window.location.origin}`}
        ></iframe>
      ) : (
        <img
          src={resource.image}
          alt={resource.title}
          className="animate-in fade-in h-[120px] rounded-md object-contain duration-1000"
        />
      )}
      {!isCurrentYoutubeLink ? (
        <Button shape="link" className="mt-sm animate-in fade-in mx-auto p-0!">
          {t("onboarding:resources.cta")}
        </Button>
      ) : null}
    </a>
  );
};

export default Resource;
